import type { JSX, ReactNode } from 'react';
import { SectionHeader } from '../ui/section-header';
import { cn } from '@/lib/utils';

/**
 * The Studio workspace on the shared vocabulary (group T, owner 28.10: header 40, section 32, row 28, density 24).
 * A pane's own header line — what is open and its ≤2 icons — is 40 px (`PANE_HEAD`); a section of a pane is headed by
 * a 32 px line: the caps `.h`, a count, ≤2 icons on the right (`PaneSection`); its lines are the 28 px `ListRow`.
 */
export const PANE_HEAD = 'pane-head flex flex-none items-center gap-2 border-b border-line px-3';

export function PaneSection({
  title,
  count,
  actions,
  children,
  className,
  testid,
  headingId,
}: {
  readonly title: ReactNode;
  readonly count?: number;
  /** ≤2 icons (IconButton) on the right of the header. */
  readonly actions?: ReactNode;
  readonly children?: ReactNode;
  readonly className?: string;
  readonly testid?: string;
  readonly headingId?: string;
}): JSX.Element {
  return (
    <section className={cn('flex flex-col', className)} data-testid={testid} aria-labelledby={headingId}>
      <div className="pane-section-head flex flex-none items-center gap-1.5" data-section-head="">
        <SectionHeader id={headingId} className="min-w-0 truncate">
          {title}
        </SectionHeader>
        {count !== undefined ? <span className="text-meta text-dim">{count}</span> : null}
        {actions !== undefined && actions !== null ? <span className="ml-auto flex flex-none items-center gap-0.5">{actions}</span> : null}
      </div>
      {children}
    </section>
  );
}
